import type { GeoBounds } from '../schemas'

/** bounding_box from API: [[sw_lng, sw_lat], [ne_lng, ne_lat]] */
export function formatBounds(
  bounds: [[number, number], [number, number]],
): GeoBounds {
  return {
    southWest: { lat: bounds[0][1], lng: bounds[0][0] },
    northEast: { lat: bounds[1][1], lng: bounds[1][0] },
  }
}
